import { type AggregatedMetrics } from '@prerender/prerender-shared/FE';

import { readDomainParam } from '~components/Filters/domainParam';

const QueryParamNames = {
  DateFrom: 'dateFrom',
  DateTo: 'dateTo',
  Domain: 'domain',
} as const;

type QueryParamName = typeof QueryParamNames[keyof typeof QueryParamNames];

const QueryParamNamesList = Object.values(QueryParamNames);

export function isDashboardV3Param(name: string): name is QueryParamName {
  return QueryParamNamesList.includes(name as QueryParamName);
}

export type DashboardV3QueryStrings = Partial<Omit<AggregatedMetrics.BaseGraphQueryParams, 'crawlers'>>;

export function buildDashboardV3QueryParameters(data: Record<string, string>): DashboardV3QueryStrings {
  return Object.entries(data).reduce<DashboardV3QueryStrings>((acc, [name, value]) => {
    if (!isDashboardV3Param(name)) return acc;

    const paramName = name as QueryParamName;

    if (paramName === QueryParamNames.DateFrom || paramName === QueryParamNames.DateTo) {
      acc[paramName] = new Date(`${value}T00:00`);
      return acc;
    }

    if (paramName === QueryParamNames.Domain) {
      const domain = readDomainParam(value);
      if (domain) acc[paramName] = domain;
      return acc;
    }

    return acc;
  }, {});
}
